





























































































import {
  Component, Prop,
  Vue, Watch,
} from 'vue-property-decorator';
import {SimProduct} from '@/types';
import SimService from '../../services/sim.service';
import GenericButton from '@/components/GenericButton.vue';
import CancelButton from '@/components/CancelButton.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';
import Dialog from '@/components/Dialog.vue';
@Component({
  components: {
    Dialog,
    ConfirmButton,
    CancelButton,
    GenericButton,
  },
})
export default class SimProductForm extends Vue {
  @Prop({default: () => []}) private filteredProducts!: SimProduct[];
  @Prop() private productData!: SimProduct;
  @Prop() private networkOperators!: Array<{[ key: string ]: string}>;
  @Prop() private formFactors!: Array<{[ key: string ]: string}>;
  @Prop() private simProducts!: SimProduct[];
  @Prop({default: false}) private showProductDialog!: boolean;
  @Prop({default: false}) private editing!: boolean;
  private product: SimProduct | null = null;
  private validForm: boolean = false;
  private simTypes: Array<{ name: string, value: string }> = [
    { name: 'Standard', value: 'standard' },
    { name: 'Industrial', value: 'industrial' },
  ];

  private baseRules: {[key: string]: any[]} = {};
  private rules: {[key: string]: any[]} = {
    product_code: [],
    name: [],
    network_operator_id: [],
    sim_form_factors: [],
    type: [],
    activation_period: [],
  };

  private mounted() {
    this.baseRules = {...this.rules};
    this.setRules();
  }

  @Watch('productData', {immediate: true})
  private onProductChange() {
    Vue.set(this, 'product', this.productData);
  }
  private selectFormFactors(e: string[]) {
    if (e.includes('MFF2') && e.length > 1) {
      e.pop();
    }
  }
  private setRules() {
    const required = (v: string): boolean | string => !!v || 'This field is required';

    for (const prop in this.rules) {
      if (this.rules.hasOwnProperty(prop)) {
        this.rules[prop].push(required);
      }
    }

    this.rules.product_code.push(
      ((v: string): boolean | string => !!v && v.length <= 25 || 'Product code exceeds maximum length'),
      ((v: string): boolean | string => !!v && !(this.filteredProducts.map((p: SimProduct) => p.product_code)).includes(v) || 'Product code must be unique'),
    );

    this.rules.product_code.push(((v: string): boolean | string => !!v && v.length <= 25 || 'Product code exceeds maximum length'));
    this.rules.sim_form_factors.push(((v: string): boolean | string => !!v && !!v.length || 'Select one or more form factors'));
    this.rules.activation_period.push(required, ((v: string): boolean | string => !!v && Number(v) > 0  || 'Activation period must be greater than 0'));

  }

  private submit() {
    this.$nextTick(() => {
      if (this.$refs.form && (this.$refs.form as any).validate()) {
        this.editing ? this.updateSimProduct() : this.addSimProduct();
        this.rules = this.baseRules;
      }
    });
  }

  private async updateSimProduct() {
    if (this.product) {
      let productToUpdate = { ...this.product, activation_period: Number(this.product.activation_period) };
      if (this.product.sim_form_factors.some((sff: any) => sff.short_code)) {
        productToUpdate = { ...productToUpdate, sim_form_factors: this.product.sim_form_factors.map((sff: any) => sff.short_code) };
      }
      const resp = await SimService.updateSimProduct(productToUpdate);
      this.$emit('close');
      this.$emit('update:products');

    }
  }


  private async addSimProduct() {
    if (this.validForm) {
      const payload: SimProduct = {
        product_code: this.productData.product_code,
        description: this.productData.description,
        name: this.productData.name,
        network_operator_id: Number(this.productData.network_operator_id),
        sim_form_factors: this.productData.sim_form_factors,
        type: this.productData.type,
        activation_period: Number(this.productData.activation_period),
      };
      await SimService.addSimProduct(payload);
      this.product = { activation_period: 365 } as SimProduct;
      this.$emit('close');
      this.$emit('update:products');

    }
  }
}
